import type { OrganizationUnitType } from '../models/organization.model';

/**
 * Which organization units a Stelle may be created on.
 *
 * Customer decision of 2026-09-25: not the root. It is a placeholder for the
 * company beneath it, and nobody works there.
 *
 * Companies, profit centres and departments keep theirs. (A station was a
 * unit type that held none until 2026-10-27; it is no unit any more.)
 *
 * One position on the root is exempt, and not by a special case here: the
 * "Owner" position that carries an organization's admins is written straight
 * to the table by organization-owners.service, never through the route this
 * guards. It has to stay there — the Owner role is scoped to `child_oe` for
 * the org-chart, and it only spans the whole tree because it hangs at the top.
 */
export function canHoldPosition(type: OrganizationUnitType): boolean {
  return type !== 'organization';
}
